(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const colorNames = ['colore', 'color', 'colour', 'couleur', 'farbe', 'kleur', 'cor'];

    const normalized = (value) =>
      String(value || '')
        .trim()
        .toLocaleLowerCase()
        .replace(/:$/, '');

    const extractMediaId = (value) => {
      const match = String(value || '').match(/(\d+)$/);
      return match ? match[1] : '';
    };

    class QiruProductVariantUx {
      constructor(productInfo) {
        if (productInfo.dataset.qiruVariantUxReady === 'true') return;

        this.productInfo = productInfo;
        this.productInfo.dataset.qiruVariantUxReady = 'true';
        this.chooseOptions = productInfo.dataset.qiruChooseOptions || '';
        this.variantMap = this.readVariantMap();
        this.pendingColor = false;
        this.pendingVariant = null;
        this.releaseTimer = null;

        this.bindVariantChanges();
        this.bindMediaChanges();
        this.bindDawnVariantUpdates();
        this.bindSubmitGuard();
        this.initializeRequiredColor();
      }

      readVariantMap() {
        const source = this.productInfo.querySelector('[data-qiru-variant-media-map]');
        if (!source) return [];

        try {
          const parsed = JSON.parse(source.textContent);
          return Array.isArray(parsed.variants) ? parsed.variants : [];
        } catch (error) {
          return [];
        }
      }

      getPicker() {
        return this.productInfo.querySelector('variant-selects');
      }

      getGroups() {
        const picker = this.getPicker();
        if (!picker) return [];
        return Array.from(picker.querySelectorAll('fieldset, .product-form__input--dropdown'));
      }

      getGroupName(group) {
        const option = group.querySelector('[data-option-name]');
        if (option?.dataset.optionName) return normalized(option.dataset.optionName);

        const label = group.querySelector('legend, .form__label');
        return normalized(label?.textContent);
      }

      getColorGroup(groups = this.getGroups()) {
        return groups.find((group) => colorNames.includes(this.getGroupName(group)));
      }

      getGroupChoices(group) {
        const select = group.querySelector('select');
        if (select) return Array.from(select.options).filter((option) => option.value);

        return Array.from(group.querySelectorAll('input[type="radio"]'));
      }

      initializeRequiredColor() {
        const groups = this.getGroups();
        const colorGroup = this.getColorGroup(groups);
        if (!colorGroup || this.getGroupChoices(colorGroup).length < 2) return;

        const urlVariant = new URL(window.location.href).searchParams.get('variant');
        if (urlVariant) return;

        const select = colorGroup.querySelector('select');
        if (select) {
          const promptOption = document.createElement('option');
          promptOption.value = '';
          promptOption.textContent = this.chooseOptions;
          promptOption.disabled = true;
          promptOption.hidden = true;
          promptOption.selected = true;
          promptOption.setAttribute('selected', 'selected');
          promptOption.dataset.qiruPrompt = 'true';
          select.querySelectorAll('option[selected]').forEach((option) => option.removeAttribute('selected'));
          select.prepend(promptOption);
          select.value = '';
          select.required = true;
        } else {
          colorGroup.querySelectorAll('input[type="radio"]').forEach((input) => {
            input.checked = false;
            input.removeAttribute('checked');
            input.setAttribute('aria-required', 'true');
          });
        }

        const selectedValue = colorGroup.querySelector('[data-selected-value]');
        if (selectedValue) selectedValue.textContent = '';

        colorGroup.classList.add('qiru-variant-choice-required');
        this.pendingColor = true;
        this.productInfo.classList.add('qiru-selection-pending');
        this.addPrompt(colorGroup);
        this.lockSubmit();
      }

      addPrompt(colorGroup) {
        if (!this.chooseOptions || this.productInfo.querySelector('[data-qiru-variant-prompt]')) return;

        const prompt = document.createElement('p');
        prompt.id = 'QiruVariantPrompt-' + this.productInfo.dataset.section;
        prompt.className = 'qiru-variant-prompt';
        prompt.dataset.qiruVariantPrompt = 'true';
        prompt.setAttribute('role', 'status');
        prompt.textContent = this.chooseOptions;
        colorGroup.insertAdjacentElement('afterend', prompt);

        this.productInfo.querySelectorAll('.product-form__submit').forEach((button) => {
          button.setAttribute('aria-describedby', prompt.id);
        });
      }

      lockSubmit() {
        this.productInfo.querySelectorAll('.product-form__submit').forEach((button) => {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          button.dataset.qiruSelectionLocked = 'true';
          const label = button.querySelector('span');
          if (label && this.chooseOptions) label.textContent = this.chooseOptions;
        });
      }

      bindVariantChanges() {
        this.productInfo.addEventListener(
          'change',
          (event) => {
            const picker = event.target.closest('variant-selects');
            if (!picker || !this.productInfo.contains(picker) || !this.pendingColor) return;

            const group = event.target.closest('fieldset, .product-form__input--dropdown');
            const colorGroup = this.getColorGroup();
            if (!group || !colorGroup) return;

            if (group === colorGroup) {
              this.confirmColorChoice();
              return;
            }

            if (event.target.tagName === 'SELECT') this.syncSelectedAttribute(event.target);
            event.stopPropagation();
          },
          true
        );
      }

      syncSelectedAttribute(select) {
        Array.from(select.options).forEach((option) => option.removeAttribute('selected'));
        if (select.selectedOptions[0]) select.selectedOptions[0].setAttribute('selected', 'selected');
      }

      confirmColorChoice() {
        this.pendingColor = false;
        this.pendingVariant = this.findVariantForSelectedGroups();
        this.setVariantInputs(this.pendingVariant);
        this.releaseTimer = window.setTimeout(
          () => this.releasePendingUi(this.pendingVariant),
          1800
        );

        queueMicrotask(() => {
          this.productInfo
            .querySelectorAll('[data-qiru-prompt]')
            .forEach((option) => option.remove());
        });
      }

      bindDawnVariantUpdates() {
        if (typeof window.subscribe !== 'function' || !window.PUB_SUB_EVENTS?.variantChange) return;

        this.unsubscribe = window.subscribe(window.PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data?.sectionId) !== String(this.productInfo.dataset.section)) return;
          this.releasePendingUi(data?.variant || this.pendingVariant);
        });
      }

      releasePendingUi(variant = null) {
        if (this.releaseTimer) window.clearTimeout(this.releaseTimer);
        this.releaseTimer = null;
        this.pendingColor = false;
        const resolvedVariant = variant || this.pendingVariant;
        this.pendingVariant = null;
        this.setVariantInputs(resolvedVariant);

        this.productInfo.classList.remove('qiru-selection-pending');
        this.productInfo
          .querySelectorAll('.qiru-variant-choice-required')
          .forEach((group) => group.classList.remove('qiru-variant-choice-required'));
        this.productInfo
          .querySelectorAll('[data-qiru-variant-prompt]')
          .forEach((prompt) => prompt.remove());
        this.productInfo.querySelectorAll('.product-form__submit').forEach((button) => {
          button.removeAttribute('aria-describedby');
          if (!button.disabled) button.removeAttribute('aria-disabled');
          delete button.dataset.qiruSelectionLocked;
        });
      }

      bindMediaChanges() {
        const gallery = this.productInfo.querySelector('media-gallery');
        if (!gallery || this.variantMap.length === 0) return;

        gallery.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-target]');
          const mediaItem = event.target.closest('[data-media-id]');
          const mediaReference = trigger?.dataset.target || mediaItem?.dataset.mediaId;
          if (!mediaReference) return;
          window.setTimeout(() => this.selectVariantForMedia(mediaReference), 0);
        });

        gallery.querySelectorAll('slider-component').forEach((slider) => {
          slider.addEventListener('slideChanged', (event) => {
            this.selectVariantForMedia(event.detail?.currentElement?.dataset.mediaId);
          });
        });
      }

      getSelectedValues(groups) {
        return groups.map((group) => {
          const select = group.querySelector('select');
          if (select) return select.value || null;
          return group.querySelector('input[type="radio"]:checked')?.value || null;
        });
      }

      findVariantForSelectedGroups(groups = this.getGroups()) {
        const selectedValues = this.getSelectedValues(groups);
        if (selectedValues.some((value) => !value)) return null;

        return (
          this.variantMap.find((variant) =>
            variant.options.every((option, index) => option === selectedValues[index])
          ) || null
        );
      }

      setVariantInputs(variant) {
        if (!variant?.id) return;

        this.productInfo.querySelectorAll('form input[name="id"]').forEach((input) => {
          input.value = variant.id;
          input.setAttribute('value', variant.id);
          input.disabled = false;
        });
      }

      bindSubmitGuard() {
        this.productInfo.addEventListener(
          'submit',
          (event) => {
            const productForm = event.target.closest('product-form');
            if (!productForm || !this.productInfo.contains(productForm)) return;
            this.setVariantInputs(this.findVariantForSelectedGroups());
          },
          true
        );
      }

      findVariantForMedia(mediaId, groups) {
        const selectedValues = this.getSelectedValues(groups);
        const candidates = this.variantMap.filter(
          (variant) => String(variant.mediaId || '') === String(mediaId)
        );
        if (candidates.length === 0) return null;

        return candidates
          .map((variant) => {
            const score = variant.options.reduce((total, option, index) => {
              if (!selectedValues[index]) return total;
              return total + (selectedValues[index] === option ? 1 : 0);
            }, 0);
            return { variant, score };
          })
          .sort((left, right) => {
            if (left.variant.available !== right.variant.available) {
              return left.variant.available ? -1 : 1;
            }
            return right.score - left.score;
          })[0].variant;
      }

      setGroupValue(group, value) {
        const select = group.querySelector('select');
        if (select) {
          const option = Array.from(select.options).find((candidate) => candidate.value === value);
          if (!option) return null;
          Array.from(select.options).forEach((candidate) => candidate.removeAttribute('selected'));
          option.selected = true;
          option.setAttribute('selected', 'selected');
          return select;
        }

        const input = Array.from(group.querySelectorAll('input[type="radio"]')).find(
          (candidate) => candidate.value === value
        );
        if (!input) return null;
        input.checked = true;
        return input;
      }

      selectVariantForMedia(mediaReference) {
        const mediaId = extractMediaId(mediaReference);
        if (!mediaId) return;

        const groups = this.getGroups();
        const variant = this.findVariantForMedia(mediaId, groups);
        if (!variant) return;

        const currentVariantId = this.productInfo.querySelector('.product-variant-id')?.value;
        if (String(currentVariantId) === String(variant.id)) return;

        let eventTarget = null;
        const colorGroup = this.getColorGroup(groups);

        groups.forEach((group, index) => {
          const target = this.setGroupValue(group, variant.options[index]);
          if (!target) return;
          if (!eventTarget || group === colorGroup) eventTarget = target;
        });

        if (!eventTarget) return;
        if (this.pendingColor && colorGroup) this.confirmColorChoice();
        eventTarget.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    const initialize = (root = document) => {
      root.querySelectorAll('product-info[id^="MainProduct-"]').forEach(
        (productInfo) => new QiruProductVariantUx(productInfo)
      );
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize());
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
